import { Search } from "lucide-react";

import { cn } from "@/lib/cn";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Optional right-hand counter, e.g. "12 / 40". */
  count?: string;
  className?: string;
  label: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  count,
  className,
  label,
}: SearchInputProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2.5 rounded-[9px] border border-line bg-surface px-3",
        "focus-within:border-teal focus-within:ring-3 focus-within:ring-teal-wash",
        className,
      )}
    >
      <Search aria-hidden="true" className="size-4 shrink-0 text-muted" />
      <input
        type="search"
        aria-label={label}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base outline-none placeholder:text-muted/70 sm:text-[14.5px]"
      />
      {count && <span className="font-mono text-[12px] whitespace-nowrap text-muted">{count}</span>}
    </div>
  );
}
